import { useState } from "react";
import { Building2, User, Pencil, Check, Instagram } from "lucide-react";
import { api, IG_PROFILE } from "../lib/api";
import { useBusiness } from "../context/BusinessContext";
import { PageHeader, card } from "../components/PageHeader";
import { Input } from "../components/ui/input";

function KindToggle({ value, onChange, prefix }) {
  return (
    <div className="flex rounded-xl bg-slate-100 p-1">
      {[["isletme", "İşletme"], ["sahis", "Şahıs"]].map(([k, l]) => (
        <button type="button" key={k} data-testid={`${prefix}-kind-${k}`} onClick={() => onChange(k)}
          className={`rounded-lg px-3 py-1.5 text-xs font-semibold ${value === k ? "bg-white text-slate-900 shadow-sm" : "text-slate-500"}`}>{l}</button>
      ))}
    </div>
  );
}

function BusinessRow({ b, active, onSelect, reload }) {
  const [edit, setEdit] = useState(false);
  const [name, setName] = useState(b.name);
  const [kind, setKind] = useState(b.kind);
  const Icon = b.kind === "sahis" ? User : Building2;
  const save = async () => {
    await api.put(`/businesses/${b.id}`, { name, kind });
    setEdit(false);
    reload();
  };
  return (
    <div data-testid={`business-row-${b.id}`} className={`flex flex-wrap items-center gap-3 rounded-2xl border p-4 ${active ? "border-cyan-400 bg-cyan-50/60" : "border-slate-200 bg-white"}`}>
      <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-cyan-500 to-blue-900 text-white"><Icon className="h-5 w-5" /></span>
      {edit ? (
        <div className="flex flex-1 flex-wrap items-center gap-2">
          <Input data-testid={`business-edit-name-${b.id}`} value={name} onChange={(e) => setName(e.target.value)} className="h-10 max-w-xs rounded-xl" />
          <KindToggle value={kind} onChange={setKind} prefix={`edit-${b.id}`} />
          <button data-testid={`business-save-${b.id}`} onClick={save} className="rounded-lg bg-emerald-600 p-2 text-white"><Check className="h-4 w-4" /></button>
        </div>
      ) : (
        <div className="min-w-0 flex-1">
          <div className="font-semibold text-slate-900">{b.name}</div>
          <div className="text-xs text-slate-500">{b.kind === "sahis" ? "Şahıs" : "İşletme"}{active && " · Seçili"}</div>
        </div>
      )}
      {!active && <button data-testid={`business-select-${b.id}`} onClick={onSelect} className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-100">Seç</button>}
      <button data-testid={`business-edit-${b.id}`} onClick={() => setEdit(!edit)} className="rounded-lg p-2 text-slate-400 hover:bg-slate-100"><Pencil className="h-4 w-4" /></button>
    </div>
  );
}

export default function Businesses() {
  const { businesses, current, setCurrentId, reload } = useBusiness();

  return (
    <div className="space-y-6" data-testid="businesses-page">
      <PageHeader title="İşletmeler & Şahıslar" subtitle="Kayıtlı işletme ve şahıslarınız arasında üst menüden geçiş yapabilirsiniz." />
      <div className={`${card} flex flex-wrap items-center justify-between gap-3`} data-testid="business-add-info">
        <p className="text-sm text-slate-600">Yeni işletme / şahıs eklemek veya silmek için bizimle iletişime geçin.</p>
        <a href={IG_PROFILE} target="_blank" rel="noreferrer" data-testid="business-instagram-link" className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-pink-500 via-fuchsia-500 to-orange-400 px-4 py-2 text-sm font-semibold text-white">
          <Instagram className="h-4 w-4" /> @kasamnetcom
        </a>
      </div>
      <div className="grid gap-3 lg:grid-cols-2">
        {businesses.map((b) => (
          <BusinessRow key={b.id} b={b} active={b.id === current?.id} onSelect={() => setCurrentId(b.id)} reload={reload} />
        ))}
      </div>
    </div>
  );
}
